import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import StateContextProvider from "./components/stateContext.js";
import queryString from 'query-string'
import MobileApp from './components/MobileApp';
import {isMobile} from 'react-device-detect';

window.addEventListener('DOMContentLoaded', (event) => {
  console.log('DOM fully loaded and parsed');
});
const share = queryString.parse(window.location.search);
console.log(share);

ReactDOM.render(
  <StateContextProvider>
    {isMobile ? 
        <MobileApp />
      : 
        <App share={share.share ? true : false} compID={share.share} />
    }
  </StateContextProvider>,
  document.getElementById('root')
);
